import { FC, ReactNode } from 'react'

import { Button } from 'shared/ui/button'

import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  type?: 'button' | 'continue' | 'close'
  button?: ReactNode
  additionalButton?: string
  title?: ReactNode
  description?: string
  content?: ReactNode
  image?: string
  padding?: number[]
  onClick?: () => void
  onClickAdditional?: () => void
}

export const PopupContent: FC<Props> = (props) => {
  const {
    type = 'button',
    button,
    additionalButton,
    title,
    description,
    content,
    image,
    padding = [0],
    onClick,
    onClickAdditional,
  } = props

  const styleButton = {
    borderRadius: 16,
  }

  return (
    <Paper
      padding={padding}
      radius={20}
    >
      <div className={s.container}>
        {image && (
          <div className={s.image}>
            <img
              src={image}
              alt=""
            />
          </div>
        )}

        <p className={s.title}>{title}</p>

        {description && <p className={s.description}>{description}</p>}

        {content}

        <div className={s.wrapper}>
          {type === 'button' && (
            <Button
              style={styleButton}
              onClick={onClick}
            >
              <span className={s.blackColor}>{button}</span>
            </Button>
          )}

          {type === 'continue' && (
            <>
              <Button
                style={styleButton}
                onClick={onClick}
              >
                <span className={s.blackColor}>{button}</span>
              </Button>

              <Button
                variant="transparent"
                style={styleButton}
                onClick={onClickAdditional}
              >
                <span className={s.red}>{additionalButton}</span>
              </Button>
            </>
          )}

          {type === 'close' && (
            <>
              <Button
                style={styleButton}
                onClick={onClick}
              >
                <span className={s.blackColor}>{button}</span>
              </Button>

              <Button
                variant="transparent"
                style={styleButton}
                onClick={onClickAdditional}
              >
                <span className={s.blue}>{additionalButton}</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </Paper>
  )
}
